import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addBook from "../redux/books/thunk/AddBook";
import updateInfoThunk from "../redux/books/thunk/updateInfoThunk";

const AddBookForm = () => {
  const editingbook = useSelector((state) => state?.bookStore?.updatingbook);
  const dispatch = useDispatch();
  const [bookName, setBookName] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [price, setPrice] = useState(0);
  const [rating, setRating] = useState(0);
  const [featuredBook, setFeaturedBook] = useState(false);
  const [buttonType, setButtonType] = useState("Add Book");

  useEffect(() => {
    const { id, name, author, thumbnail, price, rating, featured } =
      editingbook || {};
    if (id) {
      setBookName(name);
      setAuthorName(author);
      setImageUrl(thumbnail);
      setPrice(price);
      setRating(rating);
      setFeaturedBook(featured);
      setButtonType("Update Book");
    }
  }, [editingbook]);

  // functions
  const resetFrom = () => {
    setBookName("");
    setAuthorName("");
    setImageUrl("");
    setPrice(0);
    setRating(0);
    setFeaturedBook(false);
    setButtonType("Add Book");
  };

  const submitHandlerFunc = (e) => {
    e.preventDefault();
    const { id } = editingbook || {};

    const data = {
      name: bookName,
      author: authorName,
      thumbnail: imageUrl,
      price,
      rating,
      featured: featuredBook,
    };

    if (buttonType === "Add Book") {
      dispatch(addBook(data));
    } else if (buttonType === "Update Book" && id) {
      dispatch(
        updateInfoThunk({
          ...data,
          id,
        })
      );
    }
    resetFrom();
  };

  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <form className="book-form" onSubmit={submitHandlerFunc}>
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              value={bookName}
              onChange={(e) => setBookName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              value={authorName}
              onChange={(e) => setAuthorName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                min="0"
                name="price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min="0"
                max="5"
                value={rating}
                onChange={(e) => setRating(e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              checked={featuredBook}
              onChange={() => setFeaturedBook(!featuredBook)}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {" "}
              This is a featured book{" "}
            </label>
          </div>

          <button type="submit" className="submit" id="submit">
            {buttonType}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBookForm;
